import React from 'react';
import MUIDataTable from 'mui-datatables';

// Material Resources
import { IconButton, Tooltip, Typography, TableCell } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';

// GraphQl
import { useQuery, useMutation } from '@apollo/react-hooks';

// Components & Others
import { useHistory } from 'react-router-dom';
import CustomOptions from '../../../CustomOptions';
import LoadingIndicator from '../../../LoadingIndicator';
import { LIST_PROPERTY_REGIME, DELETE_PROPERTY_REGIME } from '../queries';
import CustomColumnHeader from '../../../TableComponents/CustomColumnHeader';
import { edgeToList, getOptions } from '../../../../utils/commonFunctions';
import { textLabels } from '../../../../translations/components/MUIDataTable';

// Styles & Images
import useStyles from './styles';
import { useSnackbar } from 'notistack';

function CustomToolbar() {
  const history = useHistory();
  const handleClick = () => {
    history.push('/administrador/regimenes-patrimoniales/crear');
  };

  return (
    <Tooltip title="Nuevo régimen patrimonial">
      <IconButton color="secondary" onClick={handleClick}>
        <AddIcon />
      </IconButton>
    </Tooltip>
  );
}

function PropertyRegimeList() {
  const history = useHistory();
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();

  const [deletePropertyRegime] = useMutation(
    DELETE_PROPERTY_REGIME,
    getOptions({
      mutationName: 'deletePropertyRegime',
      modelName: 'propertyRegime',
      message: 'Régimen patrimonial eliminado con éxito.',
      enqueueSnackbar,
    })
  );
  const { loading, error, data } = useQuery(LIST_PROPERTY_REGIME);
  if (error) {
    console.error(error);
  }

  const columns = [
    {
      name: 'name',
      label: 'Nombre',
      options: {
        sort: true,
        customHeadRender: (columnMeta, updateDirection) => {
          return (
            <CustomColumnHeader
              id={0}
              key={0}
              columnMeta={columnMeta}
              updateDirection={updateDirection}
            />
          );
        },
      },
    },
    {
      name: 'society',
      label: 'Permite cónyuge',
      options: {
        sort: true,
        customHeadRender: (columnMeta, updateDirection) => {
          return (
            <CustomColumnHeader
              id={1}
              key={1}
              columnMeta={columnMeta}
              updateDirection={updateDirection}
            />
          );
        },
        customBodyRender: value => {
          const society = value;
          return <p>{society ? 'Si' : 'No'} </p>;
        },
      },
    },
  ];
  columns.push({
    name: 'id',
    label: 'Opciones',
    options: {
      sort: false,
      customBodyRender: value => {
        const id = value;
        return (
          <CustomOptions
            id={id}
            model="Régimen patrimonial"
            options={['oedit', 'odelete']}
            handleDelete={() => {
              deletePropertyRegime({ variables: { id } });
              data.listPropertyRegimes.edges = data.listPropertyRegimes.edges.filter(
                e => e.node.id !== id
              );
            }}
          />
        );
      },
      customHeadRender: columnMeta => {
        return (
          <TableCell key={2} style={{ borderBottom: 'none' }}>
            <Typography
              variant="subtitle1"
              align="left"
              className={classes.tableTitle}
            >
              {columnMeta.label}
            </Typography>
          </TableCell>
        );
      },
    },
  });

  const handleRowClick = (rowData, rowMeta) => {
    if (rowData[rowData.length - 1] && rowData[rowData.length - 1].props) {
      history.push(
        `/administrador/regimenes-patrimoniales/${
          rowData[rowData.length - 1].props.id
        }`
      );
    }
  };

  const options = {
    filterType: 'dropdown',
    responsive: 'standard',
    selectableRows: 'none',
    print: false,
    filter: false,
    download: false,
    textLabels,
    customToolbar: () => {
      return <CustomToolbar />;
    },
    onRowClick: rowData => {
      handleRowClick(rowData);
    },
  };
  return (
    <>
      {loading ? (
        <LoadingIndicator />
      ) : (
        <MUIDataTable
          title="Regímenes patrimoniales"
          data={edgeToList(data, 'listPropertyRegimes')}
          columns={columns}
          options={options}
        />
      )}
    </>
  );
}

export default PropertyRegimeList;
